<h3 class="folder-name" *ngIf="!isPreviouslyAttachedFile">
  {{ "workorder.details.attached-files" | translate }}
</h3>
<h3 class="folder-name" *ngIf="isPreviouslyAttachedFile">
  {{ "workorder.details.previously-attached-files" | translate }}
</h3>

<ul class="files-list">
  <div class="details-header">
    <label class="file-header">File</label>
    <label>Modified</label>
    <label>Size</label>
  </div>
  <div class="files-content">
    <li
      *ngFor="let file of attachedFiles$ | async"
      (click)="downloadFile(file.content!, file.name!)"
    >
      <div class="file-name">
        <mat-icon>insert_drive_file</mat-icon>
        <p>{{ file.name! | truncate }}</p>
      </div>
      <label>
        {{ file.modifiedDate | date : "dd/MM/yyyy, HH:mm" }}
      </label>
      <label> {{ file.size }} KB </label>
    </li>
  </div>
</ul>
